import { render, staticRenderFns } from "./tukar_owner.vue?vue&type=template&id=77ec9144&scoped=true"
import script from "./tukar_owner.vue?vue&type=script&lang=js"
export * from "./tukar_owner.vue?vue&type=script&lang=js"
import style0 from "./tukar_owner.vue?vue&type=style&index=0&id=77ec9144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ec9144",
  null
  
)

export default component.exports